import { pageRouting } from './pageUrl';
//AJAX 프레임
import { ajaxFrame } from '../assets/lib/ajaxForm';
//UI Actions
import { baseActions } from '../../actions/ui/uiAction';
//쿠키 호출
import { cookies } from '../assets/lib/cookies';

function pageMoveSet(titleText, pageUrl) {
	var pageCallId = '#contents';
	$('title').text(titleText);
	ajaxFrame.ajaxHtmlCall(pageCallId,'GET',pageUrl,'html', true, baseActions);
}

export const pageMoveController = {
	init:function(param) {
		pageMoveController.pageLoad(param);
	},
	pageLoad:function(param) {
		var userCheck = cookies.getCookies('user_id');
		if(param != pageRouting[0].url && (userCheck != null || userCheck != '')) {
			for (var i = 0; i <= pageRouting.length + 1; i++) {
				if(param == pageRouting[i].url) {
					pageMoveSet(pageRouting[i].title, pageRouting[i].callurl);
					break;
				}else if(param == '/' || param == '/index' || param == '') {
					//데이터 생성 페이지 인덱스 화면으로 활용
					pageMoveSet(pageRouting[2].title, pageRouting[2].callurl);
					break;
				}else if(i == pageRouting.length-1) {
					pageMoveSet('에러:404', '/error/error.html');
					break;
				}
			}
		}else{
			pageMoveSet(pageRouting[0].title, pageRouting[0].callurl);
		}
	}
}



// WEBPACK FOOTER //
// ./js/controller/route/setting.core.js